import { render, staticRenderFns } from "./AccountLedgerCostCenterWise.vue?vue&type=template&id=3163bda5&scoped=true&"
import script from "./AccountLedgerCostCenterWise.vue?vue&type=script&lang=js&"
export * from "./AccountLedgerCostCenterWise.vue?vue&type=script&lang=js&"
import style0 from "./AccountLedgerCostCenterWise.vue?vue&type=style&index=0&id=3163bda5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163bda5",
  null
  
)

export default component.exports